<script>
  import { useParams } from "svelte-navigator";
  export let userID = null;
  console.log("User ID", userID)
</script>
<div>
  User Details {userID}
</div>
